import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { renderRichText } from "@storyblok/react";
import { topiaRichText } from "@topia-app/topia-react-web";
import { motion } from "framer-motion";
import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";

export function AccordionItem(props: { header: string; detail: any }) {
  const [accordionOpen, setAccordionOpen] = useState(false);
  return (
    <motion.div
      animate={accordionOpen ? "open" : "closed"}
      className="  border-b-[2px] border-b-slate-300 p-1"
    >
      <button
        className="flex w-full cursor-pointer flex-row items-center justify-between py-6"
        onClick={() => {
          setAccordionOpen((prev) => !prev);
        }}
      >
        <motion.span
          variants={{
            open: {
              color: "rgba(3, 6, 23, 0)",
            },
            closed: {
              color: "rgba(3, 6, 23, 1)",
            },
          }}
          className="bg-gradient-to-r from-royal-purple to-rgb-blue bg-clip-text text-left text-md font-medium "
        >
          {props.header}
        </motion.span>

        <motion.span
          variants={{
            open: {
              rotate: "180deg",
              color: "rgb(124 58 237)",
            },
            closed: {
              rotate: "0deg",
              color: "#030617",
            },
          }}
        >
          <FiChevronDown className="text-2xl" />
        </motion.span>
      </button>
      {accordionOpen && (
        <motion.div
          // className={`${topiaBlockClassnames(blok)}`}
          className="text-slate-60 topia-sb-rich-text overflow-hidden"
          initial={false}
          animate={{
            height: open ? "fit-content" : "0px",
            marginBottom: open ? "20px" : "0px",
          }}
          dangerouslySetInnerHTML={{
            __html: renderRichText(props.detail),
          }}
        />
      )}
    </motion.div>
  );
}
